export default __webpack_public_path__ + "static/media/semi-detached.52607656.svg";